import { render, staticRenderFns } from "./ProductsFoundersContainer.vue?vue&type=template&id=379f4254&scoped=true&"
import script from "./ProductsFoundersContainer.vue?vue&type=script&lang=js&"
export * from "./ProductsFoundersContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFoundersContainer.vue?vue&type=style&index=0&id=379f4254&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f4254",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsFoundersProfile: require('/app/appsumo/nuxt/components/products/founders/ProductsFoundersProfile.vue').default,ProductsFoundersCard: require('/app/appsumo/nuxt/components/products/founders/ProductsFoundersCard.vue').default,ProductsFoundersBody: require('/app/appsumo/nuxt/components/products/founders/ProductsFoundersBody.vue').default})
